// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"1c62350b","678":"fef082c5","963":"8adf71cc"}[chunkId] + ".chunk.js";
};